import { createFileRoute } from '@tanstack/react-router'
import UserDetails from '../components/user-details/UserDetails'

export const Route = createFileRoute('/_a/users/$userId')({
  component: UserDetails,
})
